import { CommandGroup } from '../../lib/command.jsx';
import { typographyVariants } from '../../lib/typography.jsx';

function ComboboxGroup({
  className,
  ...props
}: React.ComponentProps<typeof CommandGroup> & {
  header?: string;
}) {
  return (
    <CommandGroup
      data-slot="combobox-group"
      value={props.header}
      className={className}
      {...props}
    >
      <div
        data-slot="combobox-group-header"
        className="sticky top-0 bg-ui-primary px-3 pt-4 pb-1 break-words"
      >
        <p
          className={typographyVariants({
            variant: 'overline1',
            color: 'secondary',
          })}
        >
          {props.header}
        </p>
      </div>
      {props.children}
    </CommandGroup>
  );
}

export default ComboboxGroup;
